import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Heading } from '@lionstep/ui';
import { Doughnut } from 'react-chartjs-2';

// Components
import NoDataLabel from './NoDataLabel';

// Styles
import styles from './charts.module.scss';

const CandidateByStage = ({ insights, formatterFunc }) => {
  const { t } = useTranslation();

  const config = formatterFunc({
    candidateByStage: insights.candidate_by_stage,
    t,
    styles,
  });

  const noData = Object.values(insights.candidate_by_stage).every(
    (value) => !value,
  );

  return (
    <>
      <Heading level={4} className={styles.doughnutTitle}>
        {t('insights_page.candidate_by_stage.title')}
        {noData && <NoDataLabel />}
      </Heading>
      <div className={styles.doughnutContainer}>
        <div className={styles.doughnutContainerChart}>
          <Doughnut {...config} />
        </div>
        <div
          id="candidateByStageLegend"
          className={styles.doughnutContainerLegend}
        />
      </div>
    </>
  );
};

CandidateByStage.propTypes = {
  formatterFunc: PropTypes.func.isRequired,
  insights: PropTypes.shape().isRequired,
};

export default CandidateByStage;
